import { useAuth } from '../../../context/AuthContext';

const StaffDashboardHome = () => {
  const { user } = useAuth(); // get staff details from auth context

  return (
    <div style={{ padding: '30px' }}>
      <h1>Welcome, {user?.name || 'Staff Member'}!</h1>
      <p>Role: {user?.role || 'Staff'}</p>
      <p>Use the sidebar to access your transactions, credit/debit, and other actions.</p>
      <p>Have a great day at work!</p>
    </div>
  );
};

export default StaffDashboardHome;
